module.exports = __webpack_public_path__ + "img/pn_loading.aeb4e69b.png";